import lib from "../js-lib/lib.js";

const ActiveLink = {
  process: () => {
    let a = lib.qsa("a");
    let path = lib.path();

    if (path === "/") {
      a.forEach((e) => {
        e.classList.remove("current-menu-item");

        if (e.classList.contains("logo")) {
          e.classList.add("current-menu-item");
          ActiveLink.voidLink(e);
        } else {
          ActiveLink.instateLink(e);
        }
      });
      return;
    }

    if (lib.qs(".journal-page-previous-next-block-34")) {
      a.forEach((e) => {
        if (e.href.includes("/journal/")) {
          e.classList.add("current-menu-item");
          ActiveLink.voidLink(e);
        } else {
          e.classList.remove("current-menu-item");
          ActiveLink.instateLink(e);
        }
      });
      return;
    }

    if (path.includes("/projects/")) {
      a.forEach((e) => {
        if (e.href.includes("/work")) {
          e.classList.add("current-menu-item");
          ActiveLink.voidLink(e);
        }

        if (!e.href.includes("/work")) {
          e.classList.remove("current-menu-item");
          ActiveLink.instateLink(e);
        }
      });
      return;
    }

    a.forEach((e) => {
      if (e.href.includes(path)) {
        e.classList.add("current-menu-item");
        ActiveLink.voidLink(e);
      }

      if (!e.href.includes(path) && e.classList.contains("current-menu-item")) {
        e.classList.remove("current-menu-item");
        ActiveLink.instateLink(e);
      }
    });
  },
  voidLink: (e) => {
    e.style.pointerEvents = "none";
  },
  instateLink: (e) => {
    e.style.pointerEvents = "all";
  },
  render: () => {
    setTimeout(ActiveLink.process, 1000);
  },
};

export { ActiveLink as default };
